import React from 'react';
import { Alert } from 'reactstrap';

import { ButtonProps } from '~components/Button';

import AppointmentForm from '~appointments/components/AppointmentForm';

interface SettingsAppointment {
  id?: string | number | null;
  client?: { full_name?: string };
}

interface ComponentProps {
  appointment: SettingsAppointment;
  fieldDefinitions: any;
  defaultValues: any;
  overrideValues: any;
  canSave: () => boolean;
  onSave: (values: any, originalValues: any) => void;
  isRepeat: boolean;
  authTag: string;
  confirmButtonProps: ButtonProps;
}

const GroupAppointmentSettings: React.FC<ComponentProps> = ({
  appointment,
  fieldDefinitions,
  defaultValues,
  overrideValues,
  canSave,
  onSave,
  authTag,
  confirmButtonProps,
}) => {
  const groupName = appointment?.client?.full_name ?? '';

  return (
    <div className="p-2 group-appointment-settings" data-cy="group-appointment-settings">
      {/* Read-only group name */}
      <div className="mb-3">
        <span className="fw-bold me-2">Group Name:</span>
        <span data-cy="group-settings-group-name-readonly">{groupName}</span>
      </div>

      {/* Info note */}
      <Alert color="info" data-cy="group-settings-info-note" className="mb-3">
        Changes to settings here do not automatically update existing worker or client sub-appointments.
      </Alert>

      {/* Full appointment edit form — settings only, with route map in the right panel */}
      <AppointmentForm
        authTag={authTag}
        fields={fieldDefinitions}
        defaultValues={defaultValues}
        overrideValues={overrideValues}
        canSave={canSave}
        save={onSave}
        isNew={false}
        isGroup={false}
        showRouteMap={true}
        confirmButtonProps={confirmButtonProps}
      />
    </div>
  );
};

export default GroupAppointmentSettings;
